import { RxDotFilled } from "react-icons/rx";
import styles from "../styles.module.css";
import { useContext } from "react";
import { FormularioContext } from "..";

export function DadosBasicos() {
  const context = useContext(FormularioContext);

  function atualizarFormulario(event: React.ChangeEvent<HTMLInputElement>) {
    let nome = event.target.name;
    let value = `${event.target.value}`.toUpperCase();

    if (nome === "A2_CGC") {
      value = formatCpfCnpj(value);
    }

    context?.setFormulario({ ...context.formulario, ...{ [nome]: value } });
  }

  // Máscara de CPF/CNPJ
  const formatCpfCnpj = (value: string) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    if (digits.length === 14) {
      return digits.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5",
      );
    }
    return value;
  };

  return (
    <>
      <br />
      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
          <span>
            CNPJ <RxDotFilled className={styles.legend} />
          </span>
          <input
            value={context?.formulario.A2_CGC}
            type="text"
            name="A2_CGC"
            onChange={atualizarFormulario}
            placeholder="00.000.000/0000-00"
            maxLength={18}
            minLength={18}
          />
          <label>Digite apenas números</label>
        </div>
      </div>
      <div className={styles.groupInput}>
        <span>
          Razão Social <RxDotFilled className={styles.legend} />
        </span>
        <input
          value={context?.formulario.A2_NOME}
          type="text"
          name="A2_NOME"
          onChange={atualizarFormulario}
          placeholder=""
          style={{ width: "100%" }}
        />
      </div>
      <div className={styles.groupInput}>
        <span>
          Nome Fantasia <RxDotFilled className={styles.legend} />
        </span>
        <input
          maxLength={20}
          value={context?.formulario.A2_NREDUZ}
          type="text"
          name="A2_NREDUZ"
          onChange={atualizarFormulario}
          placeholder=""
          style={{ width: "100%" }}
        />
      </div>

      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
          <span>Inscrição Estadual</span>
          <input
            value={context?.formulario.A2_INSCR}
            type="text"
            name="A2_INSCR"
            onChange={atualizarFormulario}
            placeholder=""
          />
          <label>Digite apenas números</label>
        </div>
        <div className={styles.groupInput}>
          <span>Inscrição Municipal</span>
          <input
            value={context?.formulario.A2_INSCRM}
            type="text"
            name="A2_INSCRM"
            onChange={atualizarFormulario}
            placeholder=""
          />
          <label>Digite apenas números</label>
        </div>
      </div>

      <div className={styles.groupInput}>
        <span>
          Senha <RxDotFilled className={styles.legend} />
        </span>
        <input
          value={context?.formulario.A2_ZSENHA}
          type="password"
          name="A2_ZSENHA"
          onChange={atualizarFormulario}
          placeholder="Senha de Acesso"
          style={{ width: "100%" }}
        />
      </div>
    </>
  );
}
